import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import type { MultiEditSelectionStatus } from '../../store/product-view/product-view.selectors';

@Component({
  selector: 'app-multi-edit-entity-selection-checkbox',
  templateUrl: './multi-edit-entity-selection-checkbox.component.html',
  styleUrls: ['./multi-edit-entity-selection-checkbox.component.scss'],
  standalone: false
})
export class MultiEditEntitySelectionCheckboxComponent implements OnChanges {
  @Input() status: MultiEditSelectionStatus;

  @Output() changed: EventEmitter<boolean>;

  protected checkboxControl: FormControl<boolean>;

  constructor() {
    this.changed = new EventEmitter<boolean>();
    this.checkboxControl = new FormControl(false);
    this.checkboxControl.valueChanges.subscribe(this.changed);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['status']) {
      if (this.status) {
        this.checkboxControl.setValue(this.status.selected || this.status.allChildrenSelected, { emitEvent: false });
        if (this.status.selectable) {
          this.checkboxControl.enable({ emitEvent: false });
        } else {
          this.checkboxControl.disable({ emitEvent: false });
        }
      } else {
        this.checkboxControl.setValue(false, { emitEvent: false });
        this.checkboxControl.disable({ emitEvent: false });
      }
    }
  }
}
